// Add your JS customizations here
jQuery(document).ready(function($) {
	// Initiate WOW Animations
	new WOW().init();


	// Smooth Scroll
	$('a[href*="#"]').on('click', function(e) {
		var target = $(this.hash);

		if (target.length) {
			e.preventDefault();

			$('html, body').animate({
				scrollTop: target.offset().top
			}, 800);
		}
	});


	// Header bar scrolled
	function scrollbarState() {
		// Header bar height
		var navHeight = $('#site-header').outerHeight();

		// Extra scroll amount
		var extraHeight = 20;

		// Total trigger point
		var scrollTrigger = navHeight + extraHeight;

		if ($(document).scrollTop() > scrollTrigger) {
			$('body').addClass('scrolled');
			$('#site-header').addClass('is-scrolled');
		} else {
			$('body').removeClass('scrolled');
			$('#site-header').removeClass('is-scrolled');
		}
	}

	scrollbarState();

	// On Scroll
	$(window).on('scroll', function () {

		// Header bar scrolled
		scrollbarState();

	});

	// Menu - Hamburger
	$('.hamburger-wrap').click(function () {
		// var target = $(this).data('target');

		// If any menus open (icon active)
		if ($('body').hasClass('menu-open')) {
			$('.hamburger').removeClass('is-active');

			$('body').removeClass('menu-open parent-menu-open');
			$('.parent-menu').removeClass('open');
			$('.menu-block, .sub-menu, .child-menu').removeClass('open');
			$('.hasSub a, .hasChild a').removeClass('active');


			// If none open
		} else {
			$('.hamburger').addClass('is-active');

			$('body').addClass('menu-open parent-menu-open');
			$('.parent-menu').addClass('open');
		}
	});

	// No Parent Triggers
	$('.noParent a').click(function () {

		$('body').removeClass('parent-menu-open');

	});

	// Main Menu - Desktop
	$('#header-menu-left .hasSub a, #footer-primary .hasSub a').click(function (event) {
		event.preventDefault();

		var target = $(this).attr('href');

		$('.hamburger').addClass('is-active');

		$('#header-menu-left .hasSub a').removeClass('active');
		$('.menu-block').removeClass('open');

		$(this).addClass('active');
		$(target).addClass('open');

		$('body').addClass('menu-open');
	});

	$('#header-menu-right .hasSub a, #footer-primary .hasSub a').click(function (event) {
		event.preventDefault();

		var target = $(this).attr('href');

		$('.hamburger').addClass('is-active');

		$('#header-menu-right .hasSub a').removeClass('active');
		$('.menu-block').removeClass('open');

		$(this).addClass('active');
		$(target).addClass('open');

		$('body').addClass('menu-open');
	});
	$('#desktop-menu .hasSub a').click(function (event) {
		event.preventDefault();

		var target = $(this).attr('href');

		$('#desktop-menu .hasSub a').removeClass('active');
		$('.sub-menu-column .menu-block, .child-menu-column .menu-block').removeClass('open')

		$(this).addClass('active');
		$(target).addClass('open');
	});
	$('#desktop-menu .hasChild a').click(function (event) {
		event.preventDefault();

		var target = $(this).attr('href');

		$('#desktop-menu .hasChild a').removeClass('active');
		$('.child-menu-column .menu-block').removeClass('open')

		$(this).addClass('active');
		$(target).addClass('open');
	});

	// Main Menu - Mobile
	$('#mobile-menu .hasSub > a').click(function (event) {
		event.preventDefault();

		var target = $(this).attr('href');

		if ($(target).hasClass('open')) {
			$('#mobile-menu .hasSub > a').removeClass('active');
			$('#mobile-menu .sub-menu').removeClass('open');

			$('#mobile-menu .hasChild > a').removeClass('active');
			$('#mobile-menu .child-menu').removeClass('open');
		} else {
			$('#mobile-menu .hasSub > a').removeClass('active');
			$('#mobile-menu .sub-menu').removeClass('open');

			$(this).addClass('active');
			$(target).addClass('open');
		}
	});
	$('#mobile-menu .hasChild > a').click(function (event) {
		event.preventDefault();

		var target = $(this).attr('href');

		if ($(target).hasClass('open')) {
			$('#mobile-menu .hasChild > a').removeClass('active');
			$('#mobile-menu .child-menu').removeClass('open');
		} else {
			$('#mobile-menu .hasChild > a').removeClass('active');
			$('#mobile-menu .child-menu').removeClass('open');

			$(this).addClass('active');
			$(target).addClass('open');
		}
	});


	// Menu Toggle
	if ($('.main-nav-toggle').length > 0) {
		$('.main-nav-toggle').click(function (event) {
			event.preventDefault();

			var target = $(this).attr('href');
			var assocLink = $(this).data('link');

			// console.log(assocLink);

			$('.hamburger').addClass('is-active');
			$('body').addClass('menu-open');

			$('#header-menu-left .hasSub a').removeClass('active');
			$('#header-menu-right .hasSub a').removeClass('active');
			$('.menu-block').removeClass('open');
			$(target).addClass('open');
			$(assocLink).addClass('active');
		});
	}





	// Main Menu — scroll and menu active state
	function checkScroll() {
		var threshold = $(window).width() <= 992 ? 200 : 200;

		var scrolled = $(window).scrollTop() > threshold;

		var subActive = $('.isSubMenu.active').length > 0;
		var childActive = $('.isChildMenu.active').length > 0;

		if (scrolled || subActive || childActive) {
			$('#wrapper-navbar').addClass('scroll-active');
		} else {
			$('#wrapper-navbar').removeClass('scroll-active');
		}
	}

	function lockScroll() {
		$('body').addClass('no-scroll');
	}

	function unlockScroll() {
		$('body').removeClass('no-scroll');
	}

	// Initial check
	checkScroll();

	// Re-run on scroll, resize
	$(window).on('scroll resize', checkScroll);

	// CTA Popup
	function setCookie(name, value) {
		document.cookie = name + "=" + value + "; path=/";
	}

	function getCookie(name) {
		let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
		return match ? match[2] : null;
	}

	// Show popup if no cookie exists
	if (!getCookie('ctaPopupDismissed')) {
		$('#cta-popup').addClass('active');
	}


	// Sliders
	$('.meet-our-team-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		adaptiveHeight: true,
		centerMode: false,
		variableWidth: false,
		prevArrow: $('.our-team-arrow-left'),
		nextArrow: $('.our-team-arrow-right'),
	});

	$('.treatment-related-treatments-slider').slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		adaptiveHeight: true,
		centerMode: false,
		variableWidth: false,
		prevArrow: $('.related-treatments-arrow-left'),
		nextArrow: $('.related-treatments-arrow-right'),
		responsive: [
			{
				breakpoint: 991,
				settings: { slidesToShow: 1 }
			}
		]
	});

	$('.treatment-case-studies-slider').slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		adaptiveHeight: true,
		centerMode: false,
		variableWidth: false,
		prevArrow: $('.case-studies-arrow-left'),
		nextArrow: $('.case-studies-arrow-right'),
		responsive: [
			{
				breakpoint: 991,
				settings: { slidesToShow: 1 }
			}
		]
	});

	if ($('.accreditation-slider').length) {
		$('.accreditation-slider').slick({
			slidesToShow: 5,
			slidesToScroll: 1,
			arrows: false,
			dots: false,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 0,
			speed: 20000,
			cssEase: 'linear',
			pauseOnHover: false,
			pauseOnFocus: false,
			centerMode: false,
			responsive: [
				{
					breakpoint: 992,
					settings: { slidesToShow: 3 }
				},
				{
					breakpoint: 576,
					settings: { slidesToShow: 2 }
				}
			]
		});
	}

	$('.our-specialisms-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		adaptiveHeight: true,
		centerMode: false,
		variableWidth: false,
		fade: true,
		speed: 600,
		cssEase: 'ease-in-out',
		prevArrow: $('.our-specialisms-arrow-left'),
		nextArrow: $('.our-specialisms-arrow-right'),
	});

	$('.case-study-gallery-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,
		arrows: false,
		asNavFor: '.case-study-gallery-nav'
	});

	$('.case-study-gallery-nav').slick({
		slidesToShow: 6,
		slidesToScroll: 1,
		asNavFor: '.case-study-gallery-slider',
		focusOnSelect: true,
		arrows: true,
		prevArrow: $('.patient-gallery-arrow-left'),
		nextArrow: $('.patient-gallery-arrow-right'),
		dots: false,
		infinite: false,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 6
				}
			},
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 6
				}
			}
		]
	});




	$(document).on('click', '.main-content-toggle', function() {

		var $toggle = $(this);
		var $content = $($toggle.attr('data-target'));

		if (!$content.length) {
			return;
		}

		var $section = $content.closest('.main-content-toggle-wrapper');

		if ($content.hasClass('is-open')) {

			var sectionTop = $section.offset().top - 150;

			$content.removeClass('is-open');
			$toggle.removeClass('is-open');
			$toggle.find('.main-content-toggle-text').text('Read More');
			$toggle.find('.main-content-toggle-icon').removeClass('fa-xmark').addClass('fa-plus');

			$('html, body').animate({
				scrollTop: sectionTop
			}, 500);

		} else {

			$content.addClass('is-open');
			$toggle.addClass('is-open');
			$toggle.find('.main-content-toggle-text').text('Read Less');
			$toggle.find('.main-content-toggle-icon').removeClass('fa-plus').addClass('fa-xmark');

		}

	});



	// Smooth Scroll
	$('.sticky-header a').on('click', function (e) {

		const target = $(this.hash);

		if (target.length) {

			e.preventDefault();

			$('html, body').animate({

				scrollTop: target.offset().top - 175

			}, 600);

		}

	});






	$('.our-specialisms-item-wrap').on('mouseenter', function () {

		var $items = $('.our-specialisms-item-wrap');
		var $this = $(this);

		$items.each(function () {

			$(this)
				.removeClass('col-lg-6')
				.addClass('col-lg-3')
				.removeClass('active');

		});

		$this
			.removeClass('col-lg-3')
			.addClass('col-lg-6')
			.addClass('active');

	});




	$('.categories-select2 select').select2({
		placeholder: 'Categories',
		width: '100%'
	});

	$('.archive-select2 select').select2({
		placeholder: 'Archive',
		width: '100%'
	});

	$('.archive-select2 select').on('select2:select', function(e) {

		var archive_url = $(this).val();

		if (archive_url) {
			window.location.href = archive_url;
		}

	});

	$('.treatment-category-select2').select2({
		minimumResultsForSearch: Infinity,
		width: '100%'
	});

	$(document).on('select2:select', '.treatment-category-select2', function (e) {
		var url = e.params.data.id;
		if (url) {
			window.location.href = url;
		}
	});



	// Case Studies Filters
	$('.case-studies-categories-select2 select').select2({
		allowClear: false,
		width: '100%',
		minimumResultsForSearch: Infinity
	});

	$('.surgeons-select2 select').select2({
		allowClear: false,
		width: '100%',
		minimumResultsForSearch: Infinity
	});

	var $grid = $('.case-studies-grid');

	if (!$grid.length) {
		return;
	}

	$grid.imagesLoaded(function() {

		$grid.isotope({
			itemSelector: '.case-study-item',
			layoutMode: 'fitRows'
		});

	});

	$('.case-study-filter').on('change', function() {

		var category = $('#case-study-category').val();
		var surgeon = $('#case-study-surgeon').val();

		$grid.isotope({
			filter: function() {

				var itemCategory = $(this).attr('data-category');
				var itemSurgeons = $(this).attr('data-surgeons');

				var categoryMatch = !category || itemCategory === category;
				var surgeonMatch = !surgeon || itemSurgeons.split(',').includes(surgeon);

				return categoryMatch && surgeonMatch;

			}
		});

		var visibleItems = $grid.isotope('getFilteredItemElements').length;

		if (visibleItems === 0) {
			$('.case-study-no-results').show();
		} else {
			$('.case-study-no-results').hide();
		}

	});

});
